export default {
  405: {
    title: 'Conta e Pesquisa não encontradas!',
    body: 'Verifique se a conta e pesquisa estão corretas.',
    return: 'Voltar'
  },
  406: {
    title: 'Dashboard não encontrado!',
    body: 'Verifique se essa pesquisa realmente tem um dashboard, se você está logado ou se o dashboard está público.',
    return: 'Voltar'
  },
  404: {
    title: 'Página não encontrada!',
    body: 'Essa página não existe. Verifique o link de acesso antes de continuar.',
    return: 'Voltar'
  },
  403: {
    title: 'Acesso não permitido!',
    body: 'Você não tem a permissão necessária para acessar essa página.',
    return: 'Voltar'
  },
  500: {
    title: 'Erro de Comunicação!',
    body: 'A página demorou muito para responder. Atualize ou tente novamente.',
    return: 'Voltar'
  },
  noPermission: 'Você não possui permissão para realizar esta ação.'
};
